var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgModifyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-1,.cls-3{fill-rule:evenodd;}.cls-2{mask:url(#mask);}"), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 52.979,
    y: 62.771,
    width: 394.042,
    height: 390.333,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    className: "cls-1",
    points: "52.979 62.775 447.004 62.775 447.004 453.103 52.979 453.103 52.979 62.775"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    className: "cls-3",
    d: "M417.82,143.765a52.338,52.338,0,0,1-13.826,35.276l-74.2-73.6a53.2,53.2,0,0,1,35.5-13.686c28.955,0,52.523,23.347,52.523,52.012Zm-34.49,55.793L206.794,373.915l-73.507-72.9,175.8-175.089ZM179.487,387.82,90.309,416.168,119.166,328ZM365.223,62.771a82.306,82.306,0,0,0-57.689,23.712L102.314,290.774a13.637,13.637,0,0,0-3.149,4.9L53.7,434.124a14.338,14.338,0,0,0,3.543,14.71A14.637,14.637,0,0,0,67.6,453.1a14.917,14.917,0,0,0,4.428-.683l139.314-44.3.787-.366a13.99,13.99,0,0,0,4.945-3.123L413.982,210.194l9.2-9.124a80.975,80.975,0,0,0,23.838-57.232v-.025c0-44.693-36.7-81.042-81.8-81.042Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModifyIcon);
export default __webpack_public_path__ + "static/media/ModifyIcon.197ec44608a45b24fed16e5cdbb9358f.svg";
export { ForwardRef as ReactComponent };